import type { IStyle } from "@fluentui/react/lib/Styling";

/**
 * Shared `subMenuIcon` style that vertically centers the submenu expand chevron
 * (ChevronRight) with a menu item's icon and label. The acui menu item renders
 * the chevron top-aligned in the row rather than centered;
 * centering its flex box on the row cross-axis lines it up independent of row
 * height, and a 2px nudge corrects the small residual offset of the glyph within
 * its box.
 *
 * Applied centrally to every ribbon overflow/flyout menu item via
 * `useControlInMenuRendererFunction`, and reused by individual controls that
 * supply their own `IMenuItemStyles` so they stay in sync with the central rule.
 */
export const submenuChevronStyle: IStyle = {
    alignSelf: "center",
    marginTop: "2px",
};
